"use client";

import { useState } from "react";
import { renderRichText } from "@storyblok/react";
import { storyblokEditable } from "@storyblok/react/rsc";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { GridContainer } from "@/components/layout/GridContainer";
import { RichText } from "@/components/typography/RichText";
import type { FaqSectionStoryblok } from "@/component-types-sb";

type FaqSectionProps = {
  blok: FaqSectionStoryblok;
};

const FaqSection = ({ blok }: FaqSectionProps) => {
  const [value, setValue] = useState("");

  return (
    <GridContainer {...storyblokEditable(blok)} className="py-4 !px-0">
      <section className="col-span-12 lg:col-span-10 lg:col-start-2 px-2 bg-sand-50 rounded-3xl py-4 md:px-14 md:py-8 flex flex-col items-center gap-4">
        {(blok.subline || blok.headline) && (
          <div className="flex flex-col gap-1 text-center">
            {blok.subline && <p className="text-copy-bold">{blok.subline}</p>}
            {blok.headline && (
              <h2 className="text-headline-xl text-black">{blok.headline}</h2>
            )}
          </div>
        )}

        <Accordion
          type="single"
          collapsible
          onValueChange={setValue}
          className="w-full flex flex-col gap-2"
        >
          {blok.items?.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-sand-100 rounded-xl border-none overflow-hidden"
            >
              <AccordionTrigger className="px-4 py-2 text-copy hover:no-underline text-left font-normal">
                {item.name}
              </AccordionTrigger>
              <AccordionContent className="text-black px-4 pb-4 text-lg">
                <RichText html={renderRichText(item.text)} />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </GridContainer>
  );
};

export default FaqSection;
